// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__v_xFF","title":"Header_title__3bm4i","left":"Header_left__2G0uz","clinicName":"Header_clinicName__1zFFW"};